import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { PickingInfo } from '@deck.gl/core/typed';
import { GetTargetPathResponse, SimpleRoute, TargetPathPositionData } from 'ais-facade-api/api';

const initialState = {
  selectedVessels: [] as any[],
  selectedPorts: [] as any[],
  selectedGeofences: [] as any[],
  hoveredRoutePoint: {} as PickingInfo,
  selectedTarget: {} as { target: PickingInfo; type: 'vessel' | 'port' | 'terminal' | 'aton' },
  route: {
    isShown: false,
    route: [] as GetTargetPathResponse,
    routePoints: [] as TargetPathPositionData[],
  },
  predictedRoute: {
    route: null as SimpleRoute | null,
    isShown: false,
  },
  findTarget: false,
};

export const selectedTargetsSlice = createSlice({
  name: 'selectedTargets',
  initialState: initialState,
  reducers: {
    addSelectedVessel: (state, action: PayloadAction<any>) => {
      state.selectedVessels = [...state.selectedVessels, action.payload];
    },
    setSelectedTarget: (state, action: PayloadAction<any>) => {
      state.selectedTarget = action.payload;
    },
    setRouteForSelectedVessel: (state, action: PayloadAction<any>) => {
      state.route = {
        route: action.payload.route,
        routePoints: action.payload.routePoints,
        isShown: action.payload.isShown,
      };
    },
    setHoveredRoutePoint: (state, action: PayloadAction<any>) => {
      state.hoveredRoutePoint = action.payload;
    },
    setFindTarget: (state, action: PayloadAction<any>) => {
      state.findTarget = action.payload;
    },
    setFindPort: (state, action: PayloadAction<any>) => {
      state.selectedTarget = { target: { object: action.payload }, type: 'port' } as any;
      state.findTarget = true;
    },
    setFindTerminal: (state, action: PayloadAction<any>) => {
      state.selectedTarget = { target: { object: action.payload }, type: 'terminal' } as any;
      state.findTarget = true;
    },
    setFindVessel: (state, action: PayloadAction<any>) => {
      state.selectedTarget = { target: { object: action.payload }, type: 'vessel' } as any;
      state.findTarget = true;
    },
    setFindAton: (state, action: PayloadAction<any>) => {
      state.selectedTarget = { target: { object: action.payload }, type: 'aton' } as any;
      state.findTarget = true;
    },
    setPredictedRoute: (state, action: PayloadAction<any>) => {
      state.predictedRoute = {
        ...state.predictedRoute,
        route: action.payload,
      };
    },

    changePredictedRouteVisibility: (state, action: PayloadAction<any>) => {
      state.predictedRoute = {
        ...state.predictedRoute,
        isShown: action.payload,
      };
    },
  },
});
export const {
  addSelectedVessel,
  setSelectedTarget,
  setRouteForSelectedVessel,
  setHoveredRoutePoint,
  setFindTarget,
  setFindPort,
  setFindVessel,
  setFindAton,
  setFindTerminal,
  setPredictedRoute,
  changePredictedRouteVisibility,
} = selectedTargetsSlice.actions;
export default selectedTargetsSlice.reducer;
